import { render } from "./PhotosHeader.vue?vue&type=template&id=32cae8fd"
import script from "./PhotosHeader.vue?vue&type=script&lang=js"
export * from "./PhotosHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__